// src/_Utils/authHeaders.js
const STORAGE_KEYS = ["USER_AUTH", "user_auth", "AUTH_USER"];

const readRawToken = () => {
  if (typeof window === "undefined") return "";
  for (const key of STORAGE_KEYS) {
    const raw =
      window.localStorage?.getItem(key) ??
      window.sessionStorage?.getItem(key);
    if (raw) return raw;
  }
  return "";
};

export const extractBearer = (raw) => {
  if (!raw) return "";
  try {
    const parsed = JSON.parse(raw);
    return (
      parsed?.access ||
      parsed?.token ||
      parsed?.Authorization ||
      parsed?.auth ||
      ""
    );
  } catch {
    return String(raw).trim();
  }
};

export const buildAuthHeadersFromRaw = (raw) => {
  const bearer = extractBearer(raw);
  if (!bearer) return undefined;

  const trimmed = String(bearer).trim();
  const normalized = /^bearer\s/i.test(trimmed) ? trimmed : `Bearer ${trimmed}`;
  return { Authorization: normalized };
};

export const getStoredAuthHeaders = () => {
  const raw = readRawToken();
  return buildAuthHeadersFromRaw(raw);
};
